import React, { useState, useEffect, useCallback } from "react";
import "./GalleryModal.css";

function GalleryModal({ items, startIndex, onClose }) {
  const [current, setCurrent] = useState(startIndex || 0);

  const prev = useCallback(
    () => setCurrent((i) => (i - 1 + items.length) % items.length),
    [items.length]
  );
  const next = useCallback(() => setCurrent((i) => (i + 1) % items.length), [
    items.length,
  ]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose, prev, next]);

  const item = items[current];

  return (
    <div className="gm-overlay" onClick={onClose}>
      <div className="gm-box" onClick={(e) => e.stopPropagation()}>
        {/* Top bar */}
        <div className="gm-topbar">
          <span className="gm-counter">
            {current + 1} / {items.length}
          </span>
          <button className="gm-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        {/* Main media */}
        <div className="gm-main">
          {items.length > 1 && (
            <button
              className="gm-nav gm-prev"
              onClick={prev}
              aria-label="Previous"
            >
              ‹
            </button>
          )}

          <div className="gm-media-wrap">
            {item.type === "video" ? (
              <video
                key={item.src}
                src={item.src}
                controls
                autoPlay
                muted
                loop
                playsInline
              />
            ) : (
              <img
                key={item.src}
                src={item.src}
                alt={`Screenshot ${current + 1}`}
              />
            )}
          </div>

          {items.length > 1 && (
            <button className="gm-nav gm-next" onClick={next} aria-label="Next">
              ›
            </button>
          )}
        </div>

        {/* Thumbnails */}
        {items.length > 1 && (
          <div className="gm-thumbs">
            {items.map((it, i) => (
              <button
                key={i}
                className={`gm-thumb${
                  i === current ? " gm-thumb--active" : ""
                }`}
                onClick={() => setCurrent(i)}
                aria-label={`Go to ${i + 1}`}
              >
                {it.type === "video" ? (
                  <div className="gm-thumb-play">▶</div>
                ) : (
                  <img src={it.src} alt="" />
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default GalleryModal;
